import { useEffect, useState } from "react";

/**
 * Cycles through an array of words with a typing / erasing effect.
 * Props: words (string[]), typingSpeed (ms/char), erasingSpeed (ms/char), pause (ms after full word).
 */
export default function Typewriter({
  words = [],
  typingSpeed = 75,
  erasingSpeed = 40,
  pause = 1600,
  className = "",
  cursorClassName = "",
  loop = true,
}) {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState("");
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (!words.length) return;
    const current = words[index % words.length];
    let timeout;

    if (!deleting && text === current) {
      if (!loop && index === words.length - 1) return;
      timeout = setTimeout(() => setDeleting(true), pause);
    } else if (deleting && text === "") {
      setDeleting(false);
      setIndex((i) => (i + 1) % words.length);
    } else {
      timeout = setTimeout(
        () => {
          setText(
            deleting
              ? current.slice(0, text.length - 1)
              : current.slice(0, text.length + 1)
          );
        },
        deleting ? erasingSpeed : typingSpeed
      );
    }

    return () => clearTimeout(timeout);
  }, [text, deleting, index, words, typingSpeed, erasingSpeed, pause, loop]);

  return (
    <span className={className} data-testid="typewriter">
      <span>{text}</span>
      <span
        aria-hidden="true"
        className={`inline-block w-[2px] h-[0.9em] align-[-0.1em] ml-[2px] bg-white animate-pulse ${cursorClassName}`}
      />
    </span>
  );
}
